module.exports = __webpack_public_path__ + "static/str2-3c8ec365309604b3a8f11edc4744e088.jpg";